import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { dispatchStorePage, dispatchClearPage } from '@/store/dispatches'
import { OptionInterface, FilterInterface } from '@/interfaces/page'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'

@Component
export default class ListPage extends Vue {
  options: {
    [key: string]: any;
  } = {}

  filter: {
    [key: string]: any;
  } = {}

  mounted () {
    if (this.$R.isEmpty(this.options)) {
      this.options = this.initOption()
    }
  }

  initOption () {
    return {
      sortBy: 'updatedAt',
      sortDesc: true,
      tablePage: tablePerPageOptions()
    }
  }

  async restorePage (cache: string) {
    if (!cache || cache === '') {
      return
    }

    const { options, filter } = JSON.parse(cache)
    this.filter = filter
    if (this.$R.isEmpty(options)) {
      this.options = this.initOption()
    } else {
      this.options = options
    }
  }

  async storePage () {
    const { options, filter } = this
    dispatchStorePage({
      page: this.$route.name || '',
      options: options as OptionInterface,
      filter: filter as FilterInterface
    })
  }

  async clearPage () {
    if (!this.$route.name) {
      return
    }
    this.filter = {}
    this.options = this.initOption()
    await dispatchClearPage(this.$route.name)
  }
}
